<template>
  <div class="pay-error-msg-modal">
    <el-dialog
      title="提示信息"
      :visible.sync="visible"
      width="600px"
      append-to-body
      class="pay-error-msg"
      :close-on-click-modal="false"
    >
      <div class="error-content">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="error-text" v-html="errorMsg"></div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleContinue">继续上传</el-button>
        <el-button type="primary" @click="visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PayErrorMsg',
  data() {
    return {
      visible: false,
      errorMsg: '',
    }
  },
  methods: {
    show(msg) {
      this.errorMsg = ''
      this.errorMsg = msg
      this.visible = true
    },
    handleContinue() {
      this.visible = false
      this.$emit('continue')
    },
  },
}
</script>

<style lang="scss" scoped>
.pay-error-msg {
  ::v-deep .el-dialog__body {
    padding: 20px;
    min-height: 260px;
    box-sizing: border-box;
  }
  .error-content {
    .error-text {
      max-height: 300px;
      overflow-y: auto;
      padding: 12px;
      background: #fdf6ec;
      border-radius: 4px;
      font-size: 13px;
      line-height: 22px;
      color: #e6a23c;
      word-break: break-all;
    }
  }
  .dialog-footer {
    ::v-deep .el-button {
      min-width: 90px;
    }
  }
}
</style>
